export default __webpack_public_path__ + "static/media/eh.5af76db0.jpg";